// extracted by mini-css-extract-plugin
export default {"purl":"N0LtzrYU_PIJo9ki8FiM","version":"BE72Qex5yjXs8vEjB1oX"};